import { Grid, Typography } from "@mui/material";
import { TrendChip } from "src/design/TrendChip";
import {
  colorSurface,
  colorBorder,
  shadowCard,
  radiusCard,
  colorTextPrimary,
  colorTextMuted,
} from "src/design/tokens";

export interface StatCardProps {
  label: string;
  value: string | number;
  icon: React.ReactNode;
  iconBg: string;
  iconColor: string;
  trend?: number;
  trendSuffix?: string;
}

export const StatCard = ({ label, value, icon, iconBg, iconColor, trend, trendSuffix }: StatCardProps) => (
  <Grid
    container
    sx={{
      backgroundColor: colorSurface,
      border: `1px solid ${colorBorder}`,
      borderRadius: radiusCard,
      boxShadow: shadowCard,
      px: 3,
      py: 2.5,
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      gap: 2,
      width: "100%",
      height: "100%",
      minWidth: 0,
      overflow: "hidden",
      boxSizing: "border-box",
    }}
  >
    <Grid item md={8} xs={12}>
      <Typography
        sx={{ fontSize: "0.875rem", color: colorTextMuted, fontWeight: 500, whiteSpace: "nowrap" }}
      >
        {label}
      </Typography>
      <Typography
        sx={{ fontSize: "22px", fontWeight: 700, color: colorTextPrimary, lineHeight: 1.2 }}
      >
        {value}
      </Typography>
      {trend !== undefined && (
        <Grid container alignItems="center" flexWrap="nowrap">
          <Grid item>
            <TrendChip progress={trend} />
          </Grid>
          {trendSuffix && (
            <Grid item>
              <Typography sx={{ fontSize: "0.7rem", color: colorTextMuted }}>
                {trendSuffix}
              </Typography>
            </Grid>
          )}
        </Grid>
      )}
    </Grid>
    <Grid
      item
      md={2}
      xs={10}
      sx={{
        width: 40,
        height: 40,
        borderRadius: radiusCard,
        backgroundColor: iconBg,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        color: iconColor,
        flexShrink: 0,
      }}
    >
      {icon}
    </Grid>
  </Grid>
);
